import { useQuery } from '@apollo/client/react';
import { OPTICLOCK_AGENT_MONTH_TOTALS } from '@staff-app/graphql-client';
import type { OpticlockAgentMonth } from '@staff-app/shared-types';

/**
 * Root's Time Dashboard rollup for one month.
 *
 * Agents with no entries in the month are ABSENT from the response, not present with a zero —
 * that is a server-side property of the query (it selects only from opticlock_entries), so the
 * table never needs to filter them out and cannot accidentally start showing them.
 */
export function useOpticlockAgentTotals(month: string) {
  return useQuery<{ opticlockAgentMonthTotals: OpticlockAgentMonth[] }>(
    OPTICLOCK_AGENT_MONTH_TOTALS,
    { variables: { month }, fetchPolicy: 'cache-and-network' },
  );
}

